<template>
  <div
    class="mx-8 rounded-12 pt-8 relative bg-light-grey flex flex-col overflow-hidden"
  >
    <div
      v-for="(item, i) in items"
      :key="i"
      class="flex mb-4 justify-start items-baseline px-8"
    >
      <ion-img src="/assets/button-icons/list-icon.svg" class="width-11" />
      <span
        class="ml-4 font-helvetica text-16 text-mid-dark-grey spacing-5 line-26"
        >{{ item }}</span
      >
    </div>
    <ion-img
      src="/assets/hero-2.png"
      class="w-full blend-mode-darken lg:-mt-24 -mt-20"
    />
  </div>
</template>

<script>
import { IonImg } from "@ionic/vue";

export default {
  components: {
    IonImg,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
